module.exports = __webpack_public_path__ + "static/img/sidebar-8.3cd5ded9.jpg";